import React, { useState, useEffect } from "react";
import { styled, keyframes } from "@mui/system";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

/* ---------------- Animation ---------------- */
const fadeSlide = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

/* ---------------- Styled Component ---------------- */
const AnnouncementBox = styled("div")({
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto 20px auto",
    padding: "16px 22px",
    //backgroundColor: "rgba(255,255,255,0.15)",
    //borderRadius: "12px",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    color: "white",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.95rem",
   // border: "1px solid rgba(255,255,255,0.3)",
    animation: `${fadeSlide} 0.6s ease-out`,
    textAlign: "center",
    lineHeight: 1.6,
});

/* ---------------- Component ---------------- */
export default function Announcement() {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <AnnouncementBox style={{ fontSize: isSmallScreen ? "0.8rem" : "1rem" }}>
            <NotificationsActiveIcon style={{ color: "#FFD700", fontSize: "24px" }} />

            <span>
        Join our online training and mentorship program for practical, hands‑on
        learning and personalized support. Get hands‑on training and expert
        mentorship — subscribe now to start your journey.
      </span>
        </AnnouncementBox>
    );
}
